// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"354":"2624a44ccc636630cd07","774":"55d66dd13de7ca2e2c2c","838":"f30ed41a29ea1d4e1b21"}[chunkId] + ".chunk.js";
};